<!-- Template -->

<template>
    <section id="breadcrumbs">
        <div class="container">
            <div class="row">
                <div class="col-9">
                    <div id="breadcrumb-links" v-if="loggedIn && !loading">
                        <router-link :to="{ name: 'Hospitals' }" tag="a" class="home" :class="{'last': path == undefined}">Sites</router-link>
                        <ul v-if="path">
                            <li v-for="b in path" :key="b.name">
                                <span>&gt;</span>
                                <router-link :to="b.path" tag="a" :class="{'last':b.last}" >{{b.name}}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-3">
                    <a href="#" class="logout-button" @click="logOut" v-if="loggedIn">Logout</a>
                    <router-link class="logout-button" v-if="loggedIn && path != 'Change Password'" :to="{ name: 'ChangePassword' }">Change password</router-link>
                </div>
            </div>
        </div>
        
    </section>
</template>

<!-- Script -->

<script>
    import { AccountService } from '@/services/account-service'; 

    export default {
        name: "TopNavigation",

        props: ["path", "loading"],


        created() {  
            this.AccountService = new AccountService(this.$api, this.$store, this.$router);  
        },

        computed: {
            loggedIn: function(){
                return this.AccountService.loggedIn;
            }
        },
        
        methods: {
            logOut: function() {
                this.AccountService.logout();  
            }
        }
    };
</script>

